// La richiesta lunga nella chat: il sunto nella bolla e il testo intero come allegato
// «Richiesta.md», che si apre in una finestra (lib/requestDigest).
import { useState } from 'react';
import type { RequestDigest } from '../lib/requestDigest';
import { Icon } from './Icon';
import { Markdown } from './Markdown';
import { Modal } from './Modal';

function size(text: string): string {
  const bytes = new Blob([text]).size;
  return bytes < 1024 ? `${bytes} B` : `${(bytes / 1024).toFixed(1).replace('.', ',')} KB`;
}

export function RequestDoc({ text, digest }: { text: string; digest: RequestDigest }) {
  const [open, setOpen] = useState(false);
  const n = digest.sections.length;
  return (
    <div style={{ display: 'grid', gap: 10 }}>
      {digest.title && <div style={{ font: '800 16px/22px var(--font-ui)' }}>{digest.title}</div>}
      <div style={{ whiteSpace: 'pre-wrap' }}>{digest.ask}</div>
      <button type="button" className="req-doc" onClick={() => setOpen(true)}>
        <span className="req-doc-icon">
          <Icon name="file-text" size={18} />
        </span>
        <span style={{ minWidth: 0, textAlign: 'left' }}>
          <span className="req-doc-name">Richiesta.md</span>
          <span className="req-doc-meta">
            {n > 0 ? `${n} ${n === 1 ? 'sezione' : 'sezioni'} · ` : ''}
            {size(text)} · apri
          </span>
        </span>
      </button>
      {open && (
        <Modal title="Richiesta.md" width={820} onClose={() => setOpen(false)}>
          <Markdown text={text} />
        </Modal>
      )}
    </div>
  );
}
